import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Aguardando from '../common/template/aguardando';

import { setModoTela, getLista, getListaLog } from './controleIntegracaoTMSWebcolActions';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import Select from '../common/form/select';
import LabelAndInputMask from '../common/form/labelAndInputMask';

class ControleIntegracaoTMSWebcol extends Component {

	state = {
		modalCodigo: null,
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	}

    componentWillMount() {
        this.props.getLista(this.state.data_inicial, this.state.data_final);
    }

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'lista' ? this.lista() : null}
					{this.props.modoTela == 'registro' ? this.registro() : null}
                </Content>
            </div>
        )
    }

	lista() {

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<LabelAndInputMask
							label='Data/Hora' placeholder='Informe o período inicial'
							cols='12 6 3 2'
							mask='99/99/9999'
							value={this.state.data_inicial}
							onChange={(data) => {
								this.setState({ ...this.state, data_inicial: data.target.value });
							}} />

						<LabelAndInputMask
							label='Data/Hora' placeholder='Informe o período final'
							cols='12 6 3 2'
							mask='99/99/9999'
							value={this.state.data_final}
							onChange={(data) => {
								this.setState({ ...this.state, data_final: data.target.value });
							}} />

						<Grid cols='6 6 4 2' style={{ marginTop: 28 }}>
							<Button
								text='Atualizar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.getLista(this.state.data_inicial, this.state.data_final);
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />

					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Shipping</Th>
								<Th alignCenter>Solicitacao</Th>
								<Th alignCenter>Primeiro Envio</Th>
								<Th alignCenter>Último Envio</Th>
								<Th alignCenter>Quantidade</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.filter(item => {

								if (this.state.pesquisar
									&& !(`
										${item.shipping}
										${item.solicitacao}
										${DateFormat.formatarDataHoraSqlParaTela(item.datahora_primeiro_envio)}
										${DateFormat.formatarDataHoraSqlParaTela(item.datahora_ultimo_envio)}
										${item.eventos}
									`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}

								return true;
							}).map(item => (
								<Tr key={item.solicitacao}>
									<Td alignCenter>{item.shipping}</Td>
									<Td alignCenter>{item.solicitacao}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_primeiro_envio)}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_ultimo_envio)}</Td>
									<Td alignCenter>{item.eventos}</Td>
									<Td alignRight minWidth={50}>
										<ButtonTable
											type={'primary'}
											icon={'fas fa-eye'}
											visible={true}
											event={() => {
												this.props.setModoTela('registro', {
													...item
												});
												this.props.getListaLog(item.solicitacao);
												this.setState({
													...this.state,
													filtroEvento: [
														'Shipment Inclusão', 'Shipment Alteração', 'Evento - XB', 'Evento - XX', 'Evento - X3', 'Evento - CP', 
														'Evento - AF', 'Evento - X1', 'Evento - D1', 'Evento - CD'
													]
												})
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	registro() {

		return (
			<ContentCard>

				{this.modalCodigo()}

				<ContentCardBody>
					<Row>
						<LabelAndInput
							label='Shipping'
							cols='12 6 3 2'
							readOnly={'readOnly'}
							value={this.props.registro.shipping}
							onChange={() => {}} />

						<LabelAndInput
							label='Solicitação'
							cols='12 6 3 3'
							readOnly={'readOnly'}
							value={this.props.registro.solicitacao}
							onChange={() => {}} />
						
						<Grid cols='6 6 4 2' style={{ marginTop: 28 }}>
							<Button
								text='Voltar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('lista', {});
								}} />
						</Grid>											
					</Row>
					<Table responsive>
						<THead>
							<Tr>
								<Th width={100} alignCenter>Data/Hora</Th>
								<Th width={100} alignCenter>Ocorrência</Th>
								<Th width={10} alignCenter>JSON</Th>
								<Th width={10} alignCenter>Status</Th>
								<Th width={10} alignCenter>Retorno</Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.listaLog.map(item => (
								<Tr key={item.id}>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</Td>
									<Td alignCenter>{item.nome_proceda}</Td>
									<Td alignCenter 
										title={''}>
										<ButtonTable
											type={'secondary'}
											icon={'fas fa-code'}
											visible={true}
											event={() => {
												this.setState({ 
													...this.state, 
													registroJson: JSON.stringify({
														chave_nf: item.chave_nf,
														localizacao: item.localizacao,
														latitude: item.latitude,
														longitude: item.longitude,
														placa_veiculo: item.placa_veiculo,
														cnpj_transportadora: item.cnpj_transportadora,
														previsao_entrega: item.datahora_previsao,
														ocorrencia: item.id_proceda,
														data_entrega: item.datahora_termino,
														data_geolocalizacao: item.datahora_localizacao
													})
												});
											}} />
									</Td>
									<Td alignCenter>
										{item.sucesso ? (
											<span class='badge badge-success' style={{ fontSize: 14, width: 90, padding: 6 }}>Sucesso</span>
										) : (
											<span class='badge badge-danger' style={{ fontSize: 14, width: 90, padding: 6 }}>Erro</span>
										)}
									</Td>
									<Td alignCenter 
										title={''}>
										{!item.sucesso &&
										<ButtonTable
											type={'danger'}
											icon={'fas fa-exclamation-circle'}
											visible={true}
											event={() => {
												this.setState({ ...this.state, registroErro: item.erro_retorno });
											}} />}
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	modalCodigo() {

		if (!this.state.registroJson && !this.state.registroErro) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header' style={{ backgroundColor: this.state.registroJson ? '#1F3066' : '#c70000', color: '#fff' }}>
							<h4 class='modal-title'>{this.state.registroJson ? 'JSON' : 'ERRO'}</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, registroJson: null, registroErro: null })}>
								<span aria-hidden='true' style={{ color: '#fff', fontSize: 32 }}>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ overflowY: 'scroll', paddingTop: 20 }}>
							
							<p style={{ padding: 20, backgroundColor: '#e9ecef', color: '#000', fontSize: 16 }}>
								{this.state.registroJson || this.state.registroErro}
							</p>
						</div>
					</div>
				</div>
			</div>
        );
    }

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.controleIntegracaoTMSWebcol.modoTela,
	aguardando: state.controleIntegracaoTMSWebcol.aguardando,
	registro: state.controleIntegracaoTMSWebcol.registro,
	lista: state.controleIntegracaoTMSWebcol.lista,
	listaLog: state.controleIntegracaoTMSWebcol.listaLog
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, getLista, getListaLog }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControleIntegracaoTMSWebcol);
